
























import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import LeftMenu from './LeftMenu.vue'
import TopFilter from './TopFilter.vue'
import LabelContainer from './LabelContainer.vue'
import QuestionList from './QuestionList.vue'
import listArray from '../model/index.js'

@Component({
  components: { LeftMenu, TopFilter, LabelContainer, QuestionList }
})
export default class Main extends Vue {
  public list = listArray
  private site = ''
  private isUnion = '1'

  public onSiteChange(val) {
    this.site = val
  }
  public unionChange(val) {
    this.isUnion = val
    console.log(val)
  }
}
